// import { useState } from 'react'
// import Icon from 'components/icon/icon'
import styles from './faqs.module.scss'
import { cn } from 'utils/helpers'

export default function Faqs({ items = [] }) {
    // const [faq, setFaq] = useState([])

    // const toggleFaq = k => {
    //     if (faq.indexOf(k) > -1) {
    //         setFaq(faq.filter(i => i != k))
    //     } else {
    //         setFaq([...faq, k])
    //     }
    // }
    // className={cn(styles.landingFaqBlock, faq.indexOf(k) > -1 && styles.landingFaqBlockActive)}
    //  <h3 onClick={() => toggleFaq(k)}>
    return (
        <div className={cn(styles.landingFaq, 'mb72')}>
            <div className={styles.sectionHeader}>
                <h2>Dažniausiai užduodami klausimai</h2>
            </div>
            <div className={styles.landingFaqBlocks}>
                {items.map((question, k) => (
                    <div key={k} className={cn(styles.landingFaqBlock, styles.landingFaqBlockActive)}>
                        <h3>
                            {/*<Icon icon="right" className={styles.faqIcon} />*/}
                            {question.question}
                        </h3>
                        <div
                            className={styles.landingFaqContent}
                            dangerouslySetInnerHTML={{
                                __html: question.answer
                            }}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}
